<script setup>
import { __, requestAvailableCities, decodeHTMLEntities } from '@/utils';
import { ErrorMessage, useField } from 'vee-validate';
import { computed, ref, watch } from 'vue';
import debounce from 'lodash/debounce';
import { isArray } from 'lodash';
import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
} from '@headlessui/vue';
import Loader from '@components/loader.vue';

const props = defineProps(['name', 'type', 'label', 'disabled', 'isShipping']);

const emit = defineEmits(['selected'])

const { handleChange: handleFieldChange, value } = useField(props.name);
const loading = ref(false);
const cities = ref([]);
const query = ref('');
const currentValue = ref({
    name: value || ''
});

const fetchCities = async (city_name) => {
    loading.value = true;
    let response = [];

    try {
        const data = await requestAvailableCities(city_name);
        response = isArray(data.data) ? data.data : [];
        response = response.map(item => ({
            ...item,
            name: decodeHTMLEntities(item.name),
        }))
    } catch (error) {
        console.error('Error fetching cities:', error);
    }
    loading.value = false;

    return response;
};


const handleChange = debounce(async (event) => {
    const value = event.target.value;
    query.value = value;
    handleFieldChange(value);
    if(value.length > 2) {
        cities.value = await fetchCities(value) || [];
    }
}, 300);

const handleTrimValue = (event) => {
    const value = event.target.value.trimStart();
    event.target.value = value;
};

const filteredCities = computed(() =>
    query.value.length < 2
        ? []
        : cities.value.filter((city) => {
            return city.name.toLowerCase().includes(query.value.toLowerCase());
        })
);

watch(currentValue, (value) => {
    emit('selected', value);
    handleFieldChange(value.name)
});
</script>
<template>
   <div class="field">
        <ErrorMessage :name="name" as="span" class="field__error" />
        <ErrorMessage :name="`${type}CityCode`" as="span" class="field__error" />
        <ErrorMessage :name="`${type}ShippingCityCode`" as="span" class="field__error" v-if="name === 'subscriberShippingSettlement' || name === 'companyShippingSettlement'"/>

        <label :for="name">
            {{ label }}
        </label><!-- /.form__label -->

        <div class="combobox-outer">
            <Combobox v-model="currentValue" :disabled="disabled">
                <div class="combobox-wrapper">
                    <ComboboxInput
                        @input="handleTrimValue"
                        @change="handleChange"
                        :displayValue="(item) => item.name"
                        :id="name"
                        :name="name"
                    />
                    <Loader class="align-end combobox-loader" color="#2563eb" v-if="loading" />
                </div>
                <ComboboxOptions class="combobox-options">
                    <ComboboxOption
                        class="combobox-option combobox-option--smaller"
                        v-for="city in filteredCities"
                        :key="city.code"
                        :value="city"
                    >
                        {{ city.name }}
                    </ComboboxOption>
                </ComboboxOptions>
            </Combobox>
        </div>
    </div><!-- /.field -->
</template>